<template>
  <input-container
    class="h-auto"
    :label="label"
    :label-class="labelClass"
    :assistive="assistive"
    :no-assistive="noAssistive"
    :max="max"
    :count="input ? input.length : 0"
    :char-counter="charCounter"
    :classes="classes"
    :body-styles="bodyStyles"
    :class="{ focused, disabled, invalid }">
    <template #container>
      <slot name="icon-left"></slot>
      <textarea
        class="textarea-body bg-transparent border-none w-full resize-none p-3 h-full focus:outline-none font-manrope leading-5 font-medium"
        ref="input"
        :style="textareaStyles"
        :placeholder="placeholder"
        :name="name"
        :maxlength="max"
        v-model="input"
        @focus="focus(true)"
        @blur="focus(false)"
        :disabled="disabled"
        :delay="delay"
      />
      <button type="button" v-if="showCleanButton" class="flex items-center justify-center w-8 h-8 rounded-md transition-all duration-300 cursor-pointer bg-primary-500 hover:bg-primary-600 mr-4" @click="clear">
        <UIcon name="i-pkg-action-close" class="size-4 text-white" />
      </button>
      <span class="font-manrope mr-3 md:mr-4 leading-6 text-base font-medium" v-if="enhancerLabel">{{ enhancerLabel }}</span>
    </template>
  </input-container>
</template>

<script>
import InputContainer from './input-container.vue';

export default {
  components: {
    InputContainer,
  },
  data() {
    return {
      focused: false,
      input: '',
    };
  },
  props: {
    noAssistive: {
      type: Boolean,
      default: false,
    },
    enhancerLabel: {
      type: [Boolean, String],
      default: false,
    },
    search: {
      type: Boolean,
      default: false,
    },
    clean: {
      type: Boolean,
      default: false,
    },
    value: {},
    label: {
      type: [String, Boolean],
      default: false,
    },
    labelClass: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    assistive: {
      type: [String, Boolean],
      default: false,
    },
    error: {
      type: [Boolean, String, Array],
      default: false,
    },
    classes: {
      type: String,
      default: 'pb-8',
    },
    textareaStyles: {
      type: [String, Object],
      default: '',
    },
    bodyStyles: {
      type: [String, Object],
      default: 'height: 84px !important',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    reduce: {
      type: Function,
      default: (v) => v,
    },
    delay: {
      type: Number,
      default: 0,
    },
    max: {
      type: [String, Number],
      default: 120,
    },
    charCounter: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showCleanButton() {
      return !this.disabled && this.clean && this.value.length;
    },
    invalid() {
      return Boolean(this.error || this.error.length);
    },
  },
  watch: {
    input(input) {
      this.$emit('input', this.reduce(input));
    },
    value(value) {
      this.input = this.reduce(value);
    },
  },
  methods: {
    focus(focus) {
      this.focused = focus;
    },
    blur(blur) {
      this.focused = blur;
    },
    clear() {
      this.$refs.input.clear();
    },
  },
  mounted() {
    this.input = this.reduce(this.value);
  },
};
</script>

